import React from "react";
import { PDFViewer } from "@react-pdf/renderer";
import MyDocument360 from "./MyDocument360";

function Report360() {
  return (
    <div style={{ width: "1440px" }}>
      <h1>PDF Generator</h1>
      <PDFViewer width="100%" height="600px">
        <MyDocument360 />
      </PDFViewer>
    </div>
  );
}

export default Report360;